import {Component, OnInit} from '@angular/core';
import {CategoriasServices} from '../../services/categorias.services';
import {CategoriaModel, SubcategoriaModel} from '../../models/categoria.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute} from '@angular/router';
import {forkJoin} from 'rxjs';

@Component({
  'selector': 'categoria-list',
  'templateUrl': '../../templates/admin/categorias/categoria.admin.template.html'
})
export class CategoriaAdminComponent implements OnInit {

  listCat: CategoriaModel[] = [];

  rows: any[] = [];

  columns = [
    {name: 'Nombre'},
    {name: 'Orden'},
    {name: 'Acciones'}
  ];


  constructor(private cs: CategoriasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {

    this.spinner.show();
    this.rows = [];
    this.cs.getAllCategorias().subscribe((d: any) => {
      this.listCat = d.data.categorias;

      for (let c of this.listCat) {
        this.rows.push({
          nombre: c.nombre,
          orden: c.orden,
          id: c._id,
          acciones: c._id
        });
      }
      this.rows = [...this.rows];
      this.spinner.hide();
    });
  }

  borrarCategoria(id: any) {
    // this.spinner.show();
    // this.cs.deleteCategoria(id).subscribe(d=>{
    //   console.log(d);
    //   this.spinner.hide();
    // })
  }

}

@Component({
  'selector': 'categoria-edit',
  'templateUrl': '../../templates/admin/categorias/categoria.edit.template.html'
})
export class CategoriaEditComponent implements OnInit {

  categoria: CategoriaModel;

  constructor(private cs: CategoriasServices, private spinner: NgxSpinnerService, private activeRouter: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.spinner.show();
    let id = this.activeRouter.snapshot.params.id;

    this.cs.getCategoria(id).subscribe((d:any) => {
       this.categoria =  d.data.categoria;

      this.spinner.hide();
    });
  }

  guardarCategoria() {
    console.log(this.categoria);

    this.spinner.show();
    this.cs.updateCategoria(this.categoria).subscribe((d:any) => {
      this.spinner.hide();
      if(d.data.editCategoria == 1)
        alert('Categoria editada con éxito');
    });
  }

}

@Component({
  'selector': 'categoria-new',
  'templateUrl': '../../templates/admin/categorias/categoria.new.template.html'
})
export class CategoriaNewComponent {

  categoria: CategoriaModel = new CategoriaModel();

  constructor(private cs: CategoriasServices, private spinner: NgxSpinnerService) {
  }


  updateCategoria() {

    if (this.categoria.nombre == '') {
      alert('Categoria con nombre en blanco');
      return;
    }


    this.spinner.show();
    this.cs.newCategoria(this.categoria).subscribe((d:any) => {
      if (d.data.newCategoria == 1)
        alert('Categoria creada con éxito');
      this.spinner.hide();
    });

  }
}

@Component({
  'selector': 'subcategoria-list',
  'templateUrl': '../../templates/admin/categorias/subcategoria.admin.template.html'
})
export class SubcategoriaAdminComponent implements OnInit {


  listSubcat: SubcategoriaModel[] = [];

  constructor(private cs: CategoriasServices, private spinner: NgxSpinnerService) {
  }

  rows: any[] = [];

  columns = [
    {name: 'Nombre'},
    {name: 'Categoria'},
    {name: 'Orden'},
    {name: 'Acciones'}
  ];

  ngOnInit(): void {
    this.spinner.show();
    this.rows = [];

    this.cs.getAllSubCategorias().subscribe((d: any) => {
      console.log(d);
      this.listSubcat = d.data.subcategorias;
      console.log(this.listSubcat);

      for (let s of this.listSubcat) {
        this.rows.push({
          nombre: s.nombre,
          orden: s.orden,
          id: s._id,
          categoria: s.categoria.nombre,
          acciones: s._id
        });
      }

      this.rows = [...this.rows]
      this.spinner.hide();

    });
  }

  borrarSubcat(id: any) {

  }


}

@Component({
  'selector': 'subcategoria-edit',
  'templateUrl': '../../templates/admin/categorias/subcategoria.edit.template.html'
})
export class SubcategoriaEditComponent implements OnInit {
  subcat: SubcategoriaModel;
  categorias: CategoriaModel[] = [];

  constructor(private cs: CategoriasServices, private spinner: NgxSpinnerService, private activeRouter: ActivatedRoute) {
  }

  ngOnInit(): void {
    let id = this.activeRouter.snapshot.params.id;

    this.spinner.show();

    let consultas: any[] = [];
    consultas.push(this.cs.getSubCategoria(id));
    consultas.push(this.cs.getAllCategorias());

    forkJoin(consultas).subscribe((d: any) => {
      console.log(d);

      this.subcat = d[0].data.subcategoria;
      this.categorias = d[1].data.categorias;

      // this.subcat.categoria = this.categorias.find(c=> c._id)
      this.spinner.hide();
    });


  }

  guardarSubcategoria() {
    this.spinner.show();
    this.cs.updateSubCategoria(this.subcat).subscribe(d => {
      this.spinner.hide();
    });
  }
}

@Component({
  'selector': 'subcategoria-new',
  'templateUrl': '../../templates/admin/categorias/subcategoria.new.template.html'
})
export class SubcategoriaNewComponent implements OnInit {
  subcat: SubcategoriaModel = new SubcategoriaModel();

  categorias: CategoriaModel[] = [];

  constructor(private cs: CategoriasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {

    this.spinner.show();

    this.cs.getAllCategorias().subscribe((d: any) => {
      console.log(d);
      this.categorias = d.data.categorias;
      this.spinner.hide();
    });

  }

  saveSubcategoria() {
    console.log(this.subcat);
    this.spinner.show();
    this.cs.newSubCategoria(this.subcat).subscribe(d => {
      console.log(d);
      this.spinner.hide();
    });

  }
}
